import { Dimensions, IndexedObject } from '../../types';

export const dividerDimensionsMapping: IndexedObject<Dimensions> = {
	xSmall: {
		width: '4',
		height: '32'
	},
	small: {
		width: '14',
		height: '40'
	},
	normal: {
		width: '21',
		height: '64'
	}
};
